import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setSelectedSystems } from 'features/systems';
import { useQuotedSystemsSnapshots } from 'hooks/use-quoted-unique-ids';
import { useEffect } from 'react';
import { withoutComparisonRemovedSystems } from 'utils/comparison-removal';
import { selectedSystemFromQuotedSnapshot } from 'utils/quoted-system-snapshot';
import { missingQuotedSystems } from 'utils/quoted-systems';

export default function QuotedSystemsHydrationWatcher() {
  const dispatch = useAppDispatch();
  const { selectedSystems, comparisonRemovedUniqueIds } = useAppSelector(
    (state) => state.systems
  );
  const quotedSnapshots = useQuotedSystemsSnapshots();

  useEffect(() => {
    const missing = withoutComparisonRemovedSystems(
      missingQuotedSystems(selectedSystems, quotedSnapshots),
      comparisonRemovedUniqueIds
    );
    if (missing.length === 0) return;
    dispatch(
      setSelectedSystems([
        ...selectedSystems,
        ...missing.map(selectedSystemFromQuotedSnapshot)
      ])
    );
  }, [selectedSystems, quotedSnapshots, comparisonRemovedUniqueIds, dispatch]);

  return null;
}
